import { render } from "./HeroLoader.vue?vue&type=template&id=7af2cfcb&scoped=true"
import script from "./HeroLoader.vue?vue&type=script&lang=js"
export * from "./HeroLoader.vue?vue&type=script&lang=js"

import "./HeroLoader.vue?vue&type=style&index=0&id=7af2cfcb&scoped=true&lang=css"
import "./HeroLoader.vue?vue&type=style&index=1&id=7af2cfcb&lang=css"

import exportComponent from "C:\\wamp64\\www\\montalvo.ti\\dish-frontend-web-site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af2cfcb"]])

export default __exports__